import {
  ReactElement,
  InputHTMLAttributes,
  ReactNode,
  forwardRef,
  Ref,
} from "react";

import * as S from "./styled";

type CheckboxProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type" | "onChange"
> & {
  /** Label text displayed next to the checkbox. */
  label?: ReactNode;
  /*
    Called with the new checked state when the checkbox is toggled. Required
    because this is a controlled component.
  */
  onChange: (checked: boolean) => void;
  /*
    Current checked state of the checkbox. Required because this is a controlled
    component. 
  */
  checked: boolean;
};

// Simple SVG for the checkmark used in the checkbox.
const CHECK = (
  <svg viewBox="0 0 16 16">
    <polyline
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      points="3.5 9 6.5 12 12.5 4"
    />
  </svg>
);

export const Checkbox = forwardRef(function Checkbox(
  { label, className, style, checked, onChange, ...rest }: CheckboxProps,
  ref: Ref<HTMLInputElement>
): ReactElement {
  return (
    <S.Label className={className} style={style}>
      <S.CheckboxWrapper>
        <S.Checkbox
          {...rest}
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        {CHECK}
      </S.CheckboxWrapper>
      {label != null && <span>{label}</span>}
    </S.Label>
  );
});
